import { createContext, useContext } from "react";

import { createAnalyticsServiceMock } from "@/tests/mock-analytics";
import { createMondayServiceMock } from "@/tests/mock-monday";
import { createOauthServiceMock } from "@/tests/mock-oauth";

import { AnalyticsService, type AnalyticsServiceType } from "./analytics";
import { MondayService, type MondayServiceType } from "./monday";
import { OAuthService, type OAuthServiceType } from "./oauth";
import { cliService, type RunCliService } from "./runcli";

type Context = {
  monday: MondayServiceType;
  analytics: AnalyticsServiceType;
  oauth: OAuthServiceType;
  cli: RunCliService;
};

export function createServices() {
  console.log(`OAuth Redirect URL is ${import.meta.env.VITE_OAUTH_REDIRECT_URL}`);
  console.log(`Disable License Checks is ${import.meta.env.VITE_DISABLE_LICENSE_CHECKS}`);
  const monday = new MondayService();
  const analytics = new AnalyticsService();
  const oauth = new OAuthService(analytics);
  const cli = cliService;
  return { monday, analytics, oauth, cli };
}

export function mockServices({ analytics, monday, oauth, cli }: Partial<Context> = {}) {
  return {
    monday: monday ?? createMondayServiceMock(),
    analytics: analytics ?? createAnalyticsServiceMock(),
    oauth: oauth ?? createOauthServiceMock(),
    // TODO: no mock cli yet
    cli: cli ?? cliService,
  };
}

export const ServiceContext = createContext<Context>(mockServices());

const useServiceContext = () => useContext(ServiceContext);
export { useServiceContext };
